import { create } from 'zustand';
export const useCurrentVideoTime = create(set => ({
  currentVideoTime: 0,
  setCurrentVideoTime: time => set(() => ({
    currentVideoTime: time
  })),
  hasVideoPlayed: false,
  setHasVideoPlayed: played => set(() => ({
    hasVideoPlayed: played
  })),
  isVideoFinished: false,
  setIsVideoFinished: finished => set(() => ({
    isVideoFinished: finished
  }))
}));